import { useRef } from 'react'

/**
 * Returns `value` while `open`, and the last open value once closed. Overlays keep rendering
 * their content during the exit animation; without this, callers that derive content from the
 * same state that closes them (e.g. `title={t(`x.${kind}`)}` with `kind` reset to undefined)
 * flash broken text or collapse mid-animation.
 */
export const useLatched = <T>(open: boolean, value: T): T => {
  const latched = useRef(value)
  if (open) latched.current = value
  return latched.current
}
